// extracted by mini-css-extract-plugin
export default {"timeline":"Timeline_timeline__8gGXq"};